export const structureLevel = [
  {
    displayName: "Block",
    value: "BLOCK",
  },
  {
    displayName: "District",
    value: "DISTRICT",
  },
  {
    displayName: "Chapter",
    value: "CHAPTER",
  },
  {
    displayName: "Region",
    value: "REGION",
  },
  {
    displayName: "Zone",
    value: "ZONE",
  },
  {
    displayName: "Area",
    value: "AREA",
  },
];

export const examinationLevel = [
  {
    displayName: "Entrance",
    value: "ENTRANCE",
  },
  {
    displayName: "Introductory",
    value: "INTRODUCTORY",
  },
  {
    displayName: "Intermediate",
    value: "INTERMEDIATE",
  },
  {
    displayName: "Advanced",
    value: "ADVANCED",
  },
];

export const moduleName = [
  {
    displayName: "Appointment",
    value: "APPOINTMENT",
  },
  {
    displayName: "Examination",
    value: "EXAMINATION",
  },
];
